<template>
  <div>
    <p>The information for your Profile has been retrieved successfully. Please select up to 20 publications to include in your Profile.</p>
    <div>
      <b-row class="mr-0">
        <b-col cols="8"></b-col>
        <b-col align="right"><b-button v-if="!showFetchPublicationInfo" variant="info" class="mr-0" v-on:click.prevent="fetchPublications">Fetch Publications</b-button><b-badge v-else variant="warning">Loading...</b-badge></b-col>
      </b-row>
      <b-row class="mr-0">
        <b-col cols="8"></b-col>
        <b-col align="right">Last update on: {{profile.publicationsLastUpdatedOn.substring(0,10)}}</b-col>
      </b-row>
      <p>
        <b style="font-size:14pt">Publications</b>
      </p>
      <b-form-input type="text" v-model="titleFilter" placeholder="Filter By Title"/>
      <b-row class="mb-3 ml-0 mt-3">
        <b-col class="pl-0" cols="6">
          <b-button @click="selectAll()" class="mr-1" variant="info">Select up to 20 publications</b-button>
          <b-button @click="unselectAll()" style="background-color:#28424B;border-color:#28424B">Unselect All</b-button>
        </b-col>
        <b-col class="pr-0">
          <b-button @click="changeSorting('year')" variant="info" class="ml-1" :disabled="sortBy=='year'">Sort by date
            <b-icon-sort-numeric-down-alt v-if="sortBy=='year'"></b-icon-sort-numeric-down-alt>
          </b-button>
          <b-button @click="changeSorting('title')" variant="info" class="ml-1" :disabled="sortBy=='title'">Sort by title
            <b-icon-sort-alpha-down v-if="sortBy=='title'"></b-icon-sort-alpha-down>
          </b-button>
        </b-col>
      </b-row>
      <b-form-group>
        <b-form-checkbox
          v-for="pub in filterPubsByTitle()"
          v-model="selected"
          :key="pub.id"
          :value="pub.id"
          name="checkboxes"
          stacked
          :disabled="isDisabled(pub.id)">
          <!-- for now I'm selecting the first url, because we have only one source - :TODO: should change in the future -->
          <b style="font-size:13pt; color:#0A98BE"><a v-bind:href="pub.urls[0]" target="_blank">{{pub.title}}</a>
<!--
            <b-badge v-if="newPublication(pub)" class="ml-3" variant="warning">new</b-badge>--> </b>
            <b-badge v-if="pub.analyzed" variant="success" class="ml-2">analyzed</b-badge>
            <b-badge v-else variant="warning" class="ml-2">not yet analyzed</b-badge>

            <br/>
          <span v-for="(author, authorId) in pub.authorNames">
            {{author}}<span v-if="authorId<pub.authorNames.length-1">,</span>
          </span><span v-if="pub.authorNames"> | </span>
          <span v-for="(value, key, index) in usefulPublicationProperties(pub)">
              {{value}}<span v-if="index < Object.keys(usefulPublicationProperties(pub)).length-1"> | </span>
            </span>
          <br/>
        </b-form-checkbox>
      </b-form-group>
      <!--when 20 publications are selected, the remaining ones should be disabled? -->
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="profile.publications.length"
      :per-page="perPage"
    ></b-pagination>

    <b-button type="submit" variant="info" class="mr-2" v-on:click.prevent="saveButton">Save</b-button>
    <b-modal
      id="noPublicationsPrompt"
      title="0 publications selected"
      cancel-title="No"
      ok-title="Yes"
      @ok="savePublications">
      <p>
        You haven't selected any publications. Your profile won't be complete until you select at least one publication. Do you want to save your changes anyway?
      </p>
    </b-modal>

    <b-button type="submit" variant="danger" class="mr-2" v-on:click.prevent="cancel">Cancel</b-button>
  </div>
</template>

<script>
var _ = require('lodash');
export default {
  name: 'ResearchProfileEdit',
  props: [ 'profile' ],
  data() {
    return {
      selected: this.selectedInitialState(),
      titleFilter: '',
      maxPermittedPubs: 20,
      sortBy: 'year',
      perPage: 20, // :TODO: change that to whatever we want
      currentPage: 1
    }
  },
  computed: {
    maxSelections() {
      return Math.min(this.profile.publications.length, this.maxPermittedPubs);
    },
    publicationsSorted() {
      if (this.sortBy == 'year')
        return _.orderBy(this.profile.publications, this.sortBy, 'desc');
      else
        return _.orderBy(this.profile.publications, this.sortBy, 'asc');
    },
    publicationsInPage() {
      return this.publicationsSorted.slice((this.currentPage-1)*this.perPage, this.currentPage*this.perPage)
    },
    showFetchPublicationInfo() {
      return this.$store.state.showFetchPublicationInfo;
    },
    showFetchProfileScreen() {
      return this.$store.state.showFetchProfileScreen;
    },
  },
  methods: {
    filterPubsByTitle() {
      return this.publicationsInPage.filter(pub => (pub.title.toLowerCase().indexOf(this.titleFilter.toLowerCase())>=0))
    },
    usefulPublicationProperties(pub) {
      return Object.keys(pub).filter((key) => key=='venue' || key=='year').
       reduce((pubFiltered, key) => { return Object.assign(pubFiltered, { [key]: pub[key] })}, {});
    },
    newPublication(pub) {
      const dateNow = Date.now();
      const pubDate = new Date(pub.addedOn);
      if ((pub.addedOn.substring(0,10) == this.profile.publicationsLastUpdatedOn.substring(0,10)) // get only the date if it contains also time
          && ((dateNow-pubDate.getTime())/1000/3600 < 48))
        return true;
      else
        return false;
    },
    selectedInitialState: function() {
      var selectedPubs = [];
      for (var index in this.profile.publications) {
        var pub = this.profile.publications[index];
        if (pub.selectedForProfile)
          selectedPubs.push(pub.id);
      }
      return selectedPubs;
    },
    isDisabled(pubId) {
      return this.selected.length == this.maxPermittedPubs && !this.selected.includes(pubId);
    },
    countSelections(){
      var ele=document.getElementsByName('checkboxes');
      var count = 0;
      for (var i=0; i<ele.length; i++){
        if (ele[i].checked)
        	count += 1;
      }
      return count;
    },
    selectAll() {
      var ele=document.getElementsByName('checkboxes');
      var count = this.selected.length;
      for (var i=0; i<ele.length; i++) {
        if (!ele[i].checked) {
          ele[i].checked = true;
          this.selected.push(ele[i].value);
          count++;
        }
        if (count==this.maxSelections)
          return;
      }
    },
    unselectAll() {
      var ele=document.getElementsByName('checkboxes');
      for(var i=0; i<ele.length; i++){
          ele[i].checked=false;
          var idx = this.selected.indexOf(ele[i].value);
          if (idx > -1)
            this.selected.splice(idx, 1);
      }
    },
    changeSorting(field) {
      if (this.sortBy == field) {
        if (this.sortMethod == 'asc') {
          this.sortMethod = 'desc';
        } else {
          this.sortMethod = 'asc';
        }
      } else {
        this.sortBy = field;
        this.sortMethod = 'asc'; // the first time the sort button of this field is pressed, the ascending order is selected
      }
    },
    convertIdsToString() {
      var idsString = "";
      for (var index in this.selected) {
        var id = this.selected[index];
        if (index!=0) {
          idsString += ',';
        }
        idsString += id;
      }
      return idsString;
    },
    fetchPublications() {
      var params = {
        "researchProfileId": this.profile.rpid
      }
      this.$store.dispatch("fetchPublications", params);
    },
    saveButton() {
      if (this.selected.length==0) {
        this.$bvModal.show('noPublicationsPrompt');
      } else {
        this.savePublications();
      }
    },
    savePublications () {
      var params = {
        "researchProfileId": this.profile.rpid,
        "ids":  this.convertIdsToString()
      }
      this.$store.dispatch("updatePublications", params);
      this.$emit('cancelEdit', true);
    },
    cancel () {
      this.$emit('cancelEdit', true);
    },
  }
}
</script>

<style scoped>

</style>
